/* hayakmodule */
define( '../src/hayak/sublayouts/m49-list-filter/m49-list-filter',[ 'jquery', 'lib/utils' ], function ( $, utils ) {

	'use strict';

	var ListFilter = function ( $component ) {

		this.$component = $component;

		return this;
	};

	ListFilter.prototype.init = function () {
		var _this = this;

		this.listIdentifier = this.$component.data('filter-list');
		this.$input = this.$component.find('.m49-list-filter--input');
		this.$filterButton = this.$component.find('.m49-list-filter--button');
		this.$listContainer = $(this.listIdentifier);
		this.$filterItems = this.$listContainer.find('.form-field__checkbox, .form-field__radio');
		this.$bpSections = $('.m44-bill-selector__partner, .m43-accountsel__group, .m51-smart-wallet__partner');
		this.$noMatches = this.$listContainer.find('.m49-no-matches, + .m49-no-matches');

		// bind events
		//this.$input.on('keydown', $.proxy(function () {
		//	window.setTimeout( $.proxy(this.filterList, this), 10);
		// }, this));
		this.$filterButton.on('click', $.proxy(this.filterList, this));

		$(window).on('data_loaded', function(){
			_this.init();
		});

		//if( utils.isTouchDevice() ) {

		//this.optimiseForTouchDevices();
		//}

	};

	ListFilter.prototype.filterList = function () {
		var query = this.$input.val(),
				matches;

		this.$filterItems.each(function(i, el) {
			var $el = $(el);

			// show all items if there is no search
			if ( query === '' ||
					// show item if radio is checked
					 $el.find( '.form-field__input--radio:checked' ).length ||
					// keep item if query matches account number
					 $el.find( '[data-acc-detail="acc_number"]' ).text().indexOf(query) >= 0  ||
					// keep item if query matches account name (but not status)
					 $el.find( '.m43-accountsel__name, .m44-bill-selector__name, .m51-smart-wallet__name' ).children(':first-child').text().toLowerCase().indexOf(query.toLowerCase()) >= 0  ||
					// keep item if query matches estimate
					 $el.find( '.m45-estimate-selector__id' ).text().indexOf(query) >= 0 ) {

				$el.show();
			} else {

				$el.hide(400, function () {
					//console.log(el);
				});
			}
		});

		window.setTimeout( $.proxy(function() {
			// check for matches and show message as appropriate
			matches = this.$filterItems.filter(':visible');

			if ( query === '' ||
					// check if query matches account number
					 matches.find( '[data-acc-detail="acc_number"]' ).text().indexOf(query) >= 0  ||
					// check if query matches account name (but not status)
					 matches.find( '.m43-accountsel__name, .m44-bill-selector__name, .m51-smart-wallet__name' ).children(':first-child').text().toLowerCase().indexOf(query.toLowerCase()) >= 0  ||
					// check if query matches estimate
					 matches.find( '.m45-estimate-selector__id' ).text().indexOf(query) >= 0 ) {
				this.$noMatches.hide();
			} else {
				this.$noMatches.show();
			}
		}, this), 5);

		// hide empty BP sections
		if ( this.$bpSections.length ) {
			this.$bpSections.each(function(i, el) {
				var $el = $(el),
						accountList = $el.find('.m44-bill-selector__accounts-list, .m43-accountsel__accounts-list, .m51-smart-wallet__accounts-list'),
						accountInputs = accountList.find('.form-field__checkbox, .form-field__radio');

				// hide section if no accounts are visible
				if ( accountInputs.filter('[style*="display:none;"], [style*="display: none;"]').length === accountInputs.length ) {
					$el.hide();
				} else {
					$el.show();
				}
			});
		}
	};

	return ListFilter;

} );

